export interface IAdpDonorState {
}